import { render, staticRenderFns } from "./clasificacion.vue?vue&type=template&id=957d0304"
import script from "./clasificacion.vue?vue&type=script&lang=js"
export * from "./clasificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports